/* eslint-disable react/jsx-props-no-spreading */
import Layout from 'components/layout/layout';
import fetchGlobalModule from 'lib/contentful/fetchGlobalModule';
import getLayoutItems from 'lib/contentful/getLayoutItems';
import { getResourceText } from 'lib/resources';
import getCurrency from 'lib/storeLocales/getCurrency';
import withStoreLocale from 'lib/storeLocales/staticProps/withStoreLocale';
import Head from 'next/head';
import Activate from './activate';
import ForgotPassword from './forgot-password';
import Login from './login';
import Register from './register';
import Reset from './reset';

export const staticProps = slug =>
  withStoreLocale(async context => {
    const { preview = false, previewData = null, locale, store } = context;
    const currency = getCurrency(store);

    const layout = await getLayoutItems(locale, preview, store);
    const fetchResources = async globalModuleName => {
      const globalModule = await fetchGlobalModule(globalModuleName, locale, preview);
      return globalModule ? globalModule.resourcesCollection.items : [];
    };

    const page = {
      resources: {
        global: await fetchResources('Account - Global'),
        access: await fetchResources('Account - Access'),
      },
    };

    return {
      props: {
        slug,
        page,
        ...layout,
        previewData,
        localeData: { locale, currency },
      },
    };
  });

const pages = {
  login: Login,
  register: Register,
  reset: Reset,
  'forgot-password': ForgotPassword,
  activate: Activate,
};

const Static = props => {
  const {
    slug,
    header,
    footer,
    cart,
    previewData,
    uspBanner,
    storeLocaleSelector,
    page: {
      resources: { access },
    },
  } = props;

  const Page = pages[slug];

  const t = getResourceText(access);

  if (!Page)
    throw new Error(
      `[Account] Static page [${slug}] not found! Please revisit your NextJS configuration`
    );

  return (
    <>
      <Head>
        <title>{t(`Page ${slug} title`, 'Account')}</title>
      </Head>
      <Layout
        header={header}
        footer={footer}
        cart={cart}
        previewData={previewData}
        uspBanner={uspBanner}
        storeLocaleSelector={storeLocaleSelector}
      >
        <Page {...props} />
      </Layout>
    </>
  );
};

export default Static;
